import {
  Datagrid,
  List,
  TextField,
  ExportButton,
  useListContext,
  NumberField,
} from 'react-admin'

import FilterComponent from '../../components/Filter'
import CustomMonthInput from '../../components/CustomMonthInput'
import { exportExcel } from '../../utils/exportExcel'

const exporter = records => {
  const data = records.map(record => {
    return {
      'User ID': record.userId,
      'Publisher Id': record.publisherId,
      'Entity Type': record.entityType,
      'Entity Id': record.entityId,
      'Entity title': record.title,
      'Minutes Listened': record.totalMinutesListened,
      'Entity Duration': record.duration,
      Month: record.aggregationMonth,
    }
  })
  exportExcel({
    data,
    title: 'Subscription Pool',
    type: 'xlsx',
  })
}

const Actions = ({ resource, currentSort, filterValues, exporter }) => {
  return (
    <ExportButton
      disabled={false}
      resource={resource}
      sort={currentSort}
      filter={filterValues}
      exporter={exporter}
      maxResults={1000000}
    />
  )
}

const CustomFilter = props => {
  const { filterValues } = useListContext()
  return (
    <FilterComponent {...props}>
      <CustomMonthInput label="Month" source="month" alwaysOn />
    </FilterComponent>
  )
}

const SubscriptionPoolList = props => {
  return (
    <List
      exporter={false}
      filters={<CustomFilter />}
      sort={{ field: 'id', order: 'DESC' }}
      actions={<Actions />}>
      <Datagrid bulkActionButtons={false} rowClick={false} {...props}>
        <NumberField label="ID" source="id" />
        <TextField label="Month" source="month" />
        <NumberField label="Pool Amount" source="poolAmount" />
        <NumberField
          label="Total Minutes Listened"
          source="totalMinutesListened"
        />
        <NumberField label="Price per Minute" source="pricePerMinute" />
      </Datagrid>
    </List>
  )
}

export default SubscriptionPoolList
